import { adminApi } from "../apiAdmin";

export interface TalentName {
  _id: string;
  name: string;
  email?: string;
}

// Every talent's id, name and email, A to Z, for the admin's talent pickers
// (server GET /admin/talent-names). A malformed answer counts as a failed read.
export function getTalentNames(): Promise<TalentName[]> {
  return adminApi.get("/talent-names").then((r) => {
    if (!Array.isArray(r.data?.items)) throw new Error("Malformed talent names");
    return r.data.items as TalentName[];
  });
}
